import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Slide, TextField } from "@mui/material";
import PlusIcon from "@mui/icons-material/Add";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { TransitionProps } from "@mui/material/transitions";
import { paymentService } from "../../../../../../services/payment.service";
import FastIcon from "../../../../../../shared/FastIcon";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import BankModal from "../../../../../../modal/bank-modal/BankModal";
import ConfirmModal from "../../../../../../modal/confirm-modal/ConfirmModal";
import EyeIcon from "@mui/icons-material/VisibilityOutlined";
import { courseService } from "../../../../../../services/course.service";
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const ConstructorStepFour = ({ course, setStep, handleOpenPreview }: any) => {
  const [requisites, setRequisites] = useState([]);
  const [editBank, setEditBank] = useState<any>("");
  const [price, setPrice] = useState({
    price: course.price,
    requesite_id: course.requesite_id,
  });

  const [isOpenBankModal, setIsOpenBankModal] = useState(false);
  const [deleteRequisitesModal, setDeleteRequisitesModal] = useState(false);
  const [deleteRequisites, setDeleteRequisites] = useState("");
  const navigate = useNavigate();

  const addRequisites = () => {
    setEditBank("");
    setIsOpenBankModal(true);
  };

  const handleCloseBankModal = () => {
    setIsOpenBankModal(false);
  };

  useEffect(() => {
    paymentService.getPayments().then((data) => {
      setRequisites(data.data);
    });
  }, [course.id, isOpenBankModal]);

  const DeleteRequisit = async () => {
    await paymentService.deleteRequisites(deleteRequisites).then(() => {
      if (deleteRequisites === course.requesite_id) {
        setPrice({
          ...price,
          requesite_id: "",
        });
      }
      setDeleteRequisites("");
      setDeleteRequisitesModal(false);
    });
    await paymentService.getPayments().then((data) => {
      setRequisites(data.data);
    });
  };

  const RequisitesItem = ({ item }: any) => {
    const [info, setInfo] = useState<any>("");

    const getInfo = () => {
      paymentService.getRequisites(item.id).then((data) => {
        if (data.data.length === 1) course.requesite_id = data.data[0].id;
        setInfo(data.data);
      });
    };

    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div>
            <Radio value={item.id} />
            <span className={"requisites-item-title"}>{item.name}</span>{" "}
            {!info ? (
              <span onClick={getInfo} className={"requisites-item-change-text"}>
                Раскрыть
              </span>
            ) : (
              <span
                onClick={() => setInfo("")}
                className={"requisites-item-change-text"}>
                Скрыть
              </span>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <FastIcon
              name={"editIcon"}
              sx={{ paddingRight: "12px" }}
              onClick={() => {
                setEditBank(item.id);
                setIsOpenBankModal(true);
              }}
            />
            <DeleteOutlineOutlinedIcon
              onClick={() => {
                setDeleteRequisites(item.id);
                setDeleteRequisitesModal(true);
              }}
            />
          </div>
        </div>
        {info ? (
          <div
            className="corse-content-description"
            style={{ paddingLeft: "45px" }}>
            {info.type === 0 ? (
              <>
                <div> ФИО: {info.requeiste.fullname}</div>
                <div> ИИН: {info.requeiste.iin}</div>
                <div> Наименование банка: {info.requeiste.iin}</div>
                <div> Номер счета: {info.requeiste.iin}</div>
                <div> БИК: {info.requeiste.iin}</div>
              </>
            ) : (
              <>
                <div> Наименование банка: {info.requeiste.bank_name}</div>
                <div> Компания: {info.requeiste.company_name}</div>
                <div> Адрес: {info.requeiste.address}</div>
                <div> БИК: {info.requeiste.bin}</div>
                <div> ИИК: {info.requeiste.iik}</div>
              </>
            )}
          </div>
        ) : null}
      </>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}>
      <Box>
        <div className="course-content">
          <div className="constructor-content-title mt-52">
            Стоимость курса <span>обязательно</span>
          </div>
          <div className="corse-content-description">
            Укажите стоимость за весь курс. Стоимость учитывается в тенге.
          </div>
          <TextField
            variant="outlined"
            placeholder="Введите стоимость курса"
            type="number"
            value={price.price < 0 ? "" : price.price}
            inputProps={{ min: 0 }}
            sx={{
              marginTop: "12px",
              width: 600,
              "@media (max-width:1000px)": {
                width: "100%",
              },
            }}
            onChange={(e) => {
              setPrice({
                ...price,
                price: parseInt(e.target.value),
              });
            }}
            className="without-label"
          />

          <div className="constructor-content-title mt-52">
            Реквизиты <span>обязательно</span>
          </div>
          <div className="corse-content-description">
            Укажите ваши реквизиты для последующих выплат за курс.
          </div>
          <div>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={course.requesite_id}
              name="radio-buttons-group"
              onChange={(e) => {
                setPrice({
                  ...price,
                  requesite_id: e.target.value,
                });
              }}>
              {requisites.map((el: any) => (
                <RequisitesItem item={el} />
              ))}
            </RadioGroup>
          </div>
          <Button
            sx={{
              color: "#0573E4",
              fontSize: "16px",
              fontWeight: "600",
              marginTop: "18px",
              marginBottom: "52px",
              textTransform: "none",
            }}
            className="add-field"
            onClick={() => {
              addRequisites();
            }}
            variant="text">
            <PlusIcon />
            Добавить реквизиты
          </Button>
        </div>
        <Dialog
          open={isOpenBankModal}
          onClose={handleCloseBankModal}
          TransitionComponent={Transition}
          scroll="body">
          <BankModal close={handleCloseBankModal} editData={editBank} />
        </Dialog>
        <Dialog
          open={deleteRequisitesModal}
          onClose={() => setDeleteRequisitesModal(false)}
          TransitionComponent={Transition}
          scroll="body">
          <ConfirmModal
            close={() => setDeleteRequisitesModal(false)}
            confirm={() => DeleteRequisit()}
          />
        </Dialog>
      </Box>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          bottom: 0,
          left: 0,
          top: "auto",
          right: 0,
          justifyContent: "space-between",
          backgroundColor: "#F5F8FB",
          border: "1px solid #E5E5E5",
          padding: "12px 32px 12px 32px",
          "@media (max-width:1000px)": {
            backgroundColor: "transparent",
            border: "none",
            width: "100%",
            position: "unset",
            padding: 0,
          },
        }}>
        <Box
          sx={{
            "@media (max-width:1000px)": {
              display: "flex",
              flexDirection: "column",
            },
          }}>
          <Button variant="outlined" onClick={handleOpenPreview}>
            <EyeIcon sx={{ marginRight: "12px" }} /> Предпросмотр
          </Button>
          <Button
            sx={{
              marginLeft: "12px",
              "@media (max-width:1000px)": {
                margin: "10px 0 0 0",
              },
            }}
            variant="outlined"
            onClick={() => setStep(3)}>
            Назад
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "12px",
            "@media (max-width:1000px)": {
              display: "flex",
              flexDirection: "column",
              gap: 0,
            },
          }}>
          <Button
            type="submit"
            sx={{ marginLeft: "auto" }}
            variant="outlined"
            onClick={async () => {
              if (price.price && price.requesite_id) {
                try {
                  await courseService.putCoursePrice(
                    course.id,
                    price.price,
                    price.requesite_id
                  );
                  navigate("/panel");
                } catch (error) {
                  console.error("Ошибка при сохранении черновика", error);
                }
              } else {
                console.log("Необходимо задать цену и реквизит");
              }
            }}>
            Сохранить как черновик
          </Button>

          <Button
            type="submit"
            sx={{
              marginLeft: "auto",
              "@media (max-width:1000px)": {
                margin: "10px 0 0 0",
              },
            }}
            variant="contained"
            onClick={async () => {
              try {
                if (price.price && price.requesite_id) {
                  await courseService.putCoursePrice(
                    course.id,
                    price.price,
                    price.requesite_id
                  );
                }
                setStep(5);
              } catch (error) {
                console.error("Ошибка при сохранении черновика", error);
              }
            }}>
            Далее
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ConstructorStepFour;
